export const GET_STATE_LOADING = "GET_STATE_LOADING";
export const GET_MINDSETS = "GET_MINDSETS";